import { useContext } from 'react';
import {
  PlanManagementModalContext,
  type PlanManagementModalContextValue,
} from '../components/PlanManagementModalProvider';

export function usePlanManagementModalContext(): PlanManagementModalContextValue {
  return useContext(PlanManagementModalContext);
}
